import { useLocation } from "react-router-dom";
import { pushDataLayer } from "../utils/dataLayer";

export const useTrackEvent = () => {
  const { pathname } = useLocation();
  const pageType = pathname.startsWith("/zerto") ? "smb" : "ent";

  return (data) => {
    pushDataLayer({
      page_type: pageType,
      ...data,
    });
  };
};
